import * as React from "react";
import PropTypes from 'prop-types';

const SvgPhoneFill = props => {
  if (props.id !== "_svgphonefill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><path d="M114.507 78.853a6 6 0 000 12c19.657 0 35.649 15.995 35.649 35.655a6 6 0 0012 0c0-26.277-21.375-47.655-47.649-47.655z" /><path d="M188.164 138.035a6 6 0 006-6c0-22.983-8.973-44.49-25.267-60.558-16.22-15.996-37.846-24.805-60.895-24.805a6 6 0 000 12c19.875 0 38.509 7.582 52.469 21.349 13.988 13.794 21.692 32.267 21.692 52.013a6.002 6.002 0 006.001 6.001z" /><path d="M101.842 16a6 6 0 000 12C162.583 28 212 77.425 212 138.176a6 6 0 0012 0C224 70.808 169.2 16 101.842 16zM198.645 179.696l-32.199-29.581c-3.502-3.391-8.002-5.253-12.711-5.253-4.7 0-9.198 1.858-12.698 5.241l-12.697 11.613c-6.633-3.738-18.772-11.429-30.774-23.404-11.023-11-17.84-22.155-20.927-27.837l8.548-9.162c4.122-4.219 6.481-10.277 6.481-16.666 0-6.548-3.055-12.977-8.203-17.327L56.567 41.514l-.771-.74-.889-.592c-2.6-1.73-6.16-4.099-10.836-4.099-6.111 0-11.358 3.499-13.539 8.451-3.884 6.67-12.708 24.33-14.097 38.816-3.514 28.694 10.799 57.339 46.379 92.845 43.031 42.939 74.142 47.906 93.8 47.906 15.212 0 30.52-12.306 42.155-23.023l.168-.155c3.145-2.516 5.011-6.335 5.011-10.499 0-4.293-1.982-8.218-5.303-10.728z" /></svg>;
};

SvgPhoneFill.displayName = "_svgphonefill";
SvgPhoneFill.propTypes = {
  id: PropTypes.string
};
SvgPhoneFill.defaultProps = {
  id: ''
};
export default SvgPhoneFill;